import { useEffect, useState } from 'react';

/** A coarse clock for captions that depend on elapsed time (e.g. "Fetch
 *  stalled" after an hour) without a data change of their own. `null` takes
 *  the timestamp once and never schedules an interval — for viewers who never
 *  see the time-dependent captions.
 *
 *  Epoch milliseconds, not a Date: a fresh Date is a new identity on every
 *  tick, so every memo and prop comparison downstream would see a change even
 *  when the value it reads is unchanged. */
export function useNow(intervalMs: number | null): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (intervalMs === null) return;
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
